import { createContext, useContext, useState, ReactNode } from 'react';

interface StatPortalIdContextType {
    StatPortalId: string;
    setStatPortalId: (StatPortalId: string) => void;
    selectedVuId: Number;
    setSelectedVuId: (vuId: Number) => void;
    selectedAccessionNumber: string;
    setSelectedAccessionNumber: (accessionNumber: string) => void;
    action: string;
    setAction: (accessionNumber: string) => void;
    trigger: number;
    forceUpdate: () => void;
}

const StatPortalIdContext = createContext<StatPortalIdContextType>({
    StatPortalId: "",
    setStatPortalId: () => {},
    selectedVuId: -1,
    setSelectedVuId: () => {},
    selectedAccessionNumber: "",
    setSelectedAccessionNumber: () => {},
    action: "",
    setAction: () => {},
    trigger: 0,
    forceUpdate: () => {}
});

interface StatPortalIdProviderProps {
    children: ReactNode;
}

export const StatPortalIdProvider = ({ children }: StatPortalIdProviderProps) => {
    const [StatPortalId, setStatPortalId] = useState<string>("");
    const [selectedVuId, setSelectedVuId] = useState<Number>(-1);
    const [selectedAccessionNumber, setSelectedAccessionNumber] = useState<string>("");
    const [action, setAction] = useState<string>("");
    const [trigger, setTrigger] = useState(0);
    return (
        <StatPortalIdContext.Provider 
            value={{ 
                StatPortalId, 
                setStatPortalId, 
                selectedVuId,
                setSelectedVuId,
                selectedAccessionNumber,
                setSelectedAccessionNumber,
                action,
                setAction,
                trigger,
                forceUpdate: () => setTrigger((prev) => prev + 1)
            }}
        >
            {children}
        </StatPortalIdContext.Provider>
    );
};

export const useStatPortalIdContext = () => {
    const context = useContext(StatPortalIdContext);
    if (!context) {
        throw new Error('useStatPortalIdContext must be used within a StatPortalIdProvider');
    }
    return context;
};

export default StatPortalIdContext;